export default () => ({
  play: false,

  toggle() {
    this.play = ! this.play;
  },

  init() {
    this.$watch('play', (value) => { value ? this.$refs.video.play() : this.$refs.video.pause() })
  }
})